"use client";

import type { FC, PropsWithChildren } from "react";
import { useEffect } from "react";

import classNames from "classnames";

import { usePageConfig } from "@/context/PageConfigContext";

export const DarkModeWrapper: FC<PropsWithChildren> = ({ children }) => {
  const { darkMode } = usePageConfig();

  useEffect(() => {
    document.body.classList.toggle("page--dark", darkMode);
  });

  return (
    <div
      className={classNames("theme-root", {
        "page--dark": darkMode,
      })}
    >
      {children}
    </div>
  );
};
